import { CommerceSubtypes, commonSubtypes, sendEvent, type sendEventProps } from '@repo/utils';

/**
 * Sends an event with the specified type and data to New Relic for the
 * commerce app.
 *
 * @param {event} event - Object containing the type of event and the data to be
 *                       sent.
 */
export const sendCommerceEvent = async (
  event: Omit<sendEventProps, 'app'> & { subtype?: CommerceSubtypes | commonSubtypes },
) => {
  sendEvent({ app: 'commerce', ...event });
};
